var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDangerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-danger)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2681 14.2869L10.8848 2.0423C10.5939 1.55993 10.0633 1.26025 9.49998 1.26025C8.93667 1.26025 8.40606 1.55993 8.11514 2.04234L0.731871 14.2869C0.43125 14.7855 0.422355 15.4102 0.708633 15.9171C0.99498 16.4241 1.53449 16.739 2.11668 16.739H16.8833C17.4655 16.739 18.005 16.4241 18.2914 15.9171C18.5776 15.4101 18.5687 14.7855 18.2681 14.2869ZM17.2709 15.3409C17.1921 15.4804 17.0436 15.5671 16.8833 15.5671H2.11668C1.9564 15.5671 1.80786 15.4804 1.72908 15.3409C1.65026 15.2013 1.65272 15.0293 1.73544 14.8921L9.11878 2.64748C9.19887 2.5147 9.34494 2.43219 9.50002 2.43219C9.65505 2.43219 9.80113 2.5147 9.88121 2.64748L17.2645 14.8921C17.3473 15.0294 17.3497 15.2013 17.2709 15.3409Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2681 14.2869L10.8848 2.0423C10.5939 1.55993 10.0633 1.26025 9.49998 1.26025C8.93667 1.26025 8.40606 1.55993 8.11514 2.04234L0.731871 14.2869C0.43125 14.7855 0.422355 15.4102 0.708633 15.9171C0.99498 16.4241 1.53449 16.739 2.11668 16.739H16.8833C17.4655 16.739 18.005 16.4241 18.2914 15.9171C18.5776 15.4101 18.5687 14.7855 18.2681 14.2869ZM17.2709 15.3409C17.1921 15.4804 17.0436 15.5671 16.8833 15.5671H2.11668C1.9564 15.5671 1.80786 15.4804 1.72908 15.3409C1.65026 15.2013 1.65272 15.0293 1.73544 14.8921L9.11878 2.64748C9.19887 2.5147 9.34494 2.43219 9.50002 2.43219C9.65505 2.43219 9.80113 2.5147 9.88121 2.64748L17.2645 14.8921C17.3473 15.0294 17.3497 15.2013 17.2709 15.3409Z",
    fill: "#D0021B",
    stroke: "#D0021B",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5056 6.08203C9.05982 6.08203 8.71191 6.32123 8.71191 6.74529C8.71191 8.03911 8.86411 9.89831 8.86411 11.1922C8.86414 11.5292 9.15773 11.6705 9.50564 11.6705C9.76657 11.6705 10.1362 11.5292 10.1362 11.1922C10.1362 9.89835 10.2884 8.03914 10.2884 6.74529C10.2884 6.32127 9.92966 6.08203 9.5056 6.08203Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.5056 6.08203C9.05982 6.08203 8.71191 6.32123 8.71191 6.74529C8.71191 8.03911 8.86411 9.89831 8.86411 11.1922C8.86414 11.5292 9.15773 11.6705 9.50564 11.6705C9.76657 11.6705 10.1362 11.5292 10.1362 11.1922C10.1362 9.89835 10.2884 8.03914 10.2884 6.74529C10.2884 6.32127 9.92966 6.08203 9.5056 6.08203Z",
    fill: "#D0021B",
    stroke: "#D0021B",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51641 12.4209C9.03804 12.4209 8.6792 12.8014 8.6792 13.2581C8.6792 13.7039 9.038 14.0953 9.51641 14.0953C9.96219 14.0953 10.3428 13.7039 10.3428 13.2581C10.3428 12.8014 9.96216 12.4209 9.51641 12.4209Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.51641 12.4209C9.03804 12.4209 8.6792 12.8014 8.6792 13.2581C8.6792 13.7039 9.038 14.0953 9.51641 14.0953C9.96219 14.0953 10.3428 13.7039 10.3428 13.2581C10.3428 12.8014 9.96216 12.4209 9.51641 12.4209Z",
    fill: "#D0021B",
    stroke: "#D0021B",
    strokeWidth: 2,
    mask: "url(#path-3-inside-3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-danger"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/dangerIcon.5662c1e4.svg";
export { ForwardRef as ReactComponent };